<div *ngIf="pageLoading" class="loader text-center">
	<img src="../assets/img/cc_loader.gif" />
</div>
<form [formGroup]="moduleForm" (ngSubmit)="saveData()" #modform="ngForm" *ngIf="UserModuleAccess==='Full'">
	<div class="row mb-2">
		<div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
			<ng-select [items]="languageList" bindLabel="name" bindValue="id" [clearable]="true" placeholder="Language"
				id="languageid" formControlName="languageid" appearance="outline">
			</ng-select>
		</div>
	</div>
	<div class="row mb-2">
		<div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
			<div class="form-floating">
				<textarea class="form-control" [ngClass]="{'is-invalid':showError('text')}" id="text"
					formControlName="text" placeholder=""></textarea>
				<label for="text">Text*</label>
			</div>
			<p *ngIf="showError('text')" class="text-danger">
				<span *ngIf="f.text.errors?.required">
					Required
				</span>
				<span *ngIf="f.text.errors?.incorrect">
					{{customError.text}}
				</span>
			</p>
		</div>
	</div>
	<div class="row mb-2">
		<div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
			<div class="form-floating">
				<textarea class="form-control" [ngClass]="{'is-invalid':showError('translation')}" id="translation"
					formControlName="translation" placeholder=""></textarea>
				<label for="translation">Translation*</label>
			</div>
			<p *ngIf="showError('translation')" class="text-danger">
				<span *ngIf="f.translation.errors?.required">
					Required
				</span>
				<span *ngIf="f.translation.errors?.incorrect">
					{{customError.translation}}
				</span>
			</p>
		</div>
	</div>
	<div class="row mb-2">
		<div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
			<button type="submit" class="btn btn-primary me-1">
				<fa-icon *ngIf="!showLoader" [icon]="['fas', 'save']"></fa-icon>
				<fa-icon *ngIf="showLoader" [icon]="['fas', 'spinner']" animation="spin"></fa-icon>
				Submit
			</button>
			<button type="button" class="btn btn-secondary" (click)="clearForm();">Cancel</button>
		</div>
	</div>
</form>
<div *ngIf="UserModuleAccess!=='Full'">
	<h3 class="text-center">You don't have access to this section.</h3>
</div>